import React from "react";
import { useTheme } from "@mui/material";
import { useGetTotalJobQuery } from "../../services/report.service";
import DonutChartData from "../../components/global/DonutChartData";

interface DonutChartJobProps {
  id?: string;
}

const DonutChartJob: React.FC<DonutChartJobProps> = ({ id }) => {
  const { data, isFetching, isLoading } = useGetTotalJobQuery();
  const theme = useTheme();

  const dataMapper = React.useCallback(
    (data: any, theme: any) => [
      {
        name: "Completed",
        value: data?.total_completed || 0,
        color: theme.palette.primary.main,
      },
      {
        name: "New",
        value: data?.total_created || 0,
        color: theme.palette.secondary.main,
      },
    ],
    []
  );

  return (
    <DonutChartData
      id={id}
      data={data}
      isLoading={isLoading}
      isFetching={isFetching}
      dataMapper={dataMapper}
    />
  );
};

export default DonutChartJob;
